module.exports = __webpack_public_path__ + "static/media/slider02.c97a47a1.jpg";